
import {useState, useEffect} from "react";


const sectionDivStyle = {
	marginBottom: "20px" ,
}
const sectionTitleStyle = {
	fontSize: "120%" ,
	fontWeight: "bold" ,
	marginBottom: "8px" ,
}
const sectionInstructions = {
	fontSize: "80%" ,
	fontStyle: "italic" ,
	marginLeft: "15px" ,
	marginBottom: "8px" ,
}
const fieldPStyle = {
	marginLeft: "15px" ,
	marginBottom: "8px" ,
}
const fieldLabelStyle = {
	marginRight: "10px" ,
}





export default function TipCalculator () {
	let [total,setTotal] = useState ( "" )
	let [subtotal,setSubtotal] = useState ( "" )
	
	let [tax,setTax] = useState ( "" )
	let [taxRate,setTaxRate] = useState ( "" )
	
	let [extraPrinciple,setExtraPrinciple] = useState ( "" )
	let [futureDiscount,setFutureDiscount] = useState ( "" )
		
	useEffect ( () => {
		document.title = "Tip Optimizer"
	} , [] )
	
	
	function buildField ( value , setter ) {
		function callback ( ev ) {
			setter ( ev.target.value )
			//console.log ( ev.target.value )
		}
		const style = {
			fontSize: '16px' ,
			width: "72px" ,
		}
		return (
			<input
			type="number"
			inputmode="decimal"
			pattern="^[0-9]*[.,]?[0-9]*$"
			autocomplete="off"
			enterkeyhint="done"
			value={value}
			onChange={callback}
			style={style}
			/>
		)
	}
	
	
	const divStyle = {
		margin: "20px" ,
	}
	
	return (
		<div style={divStyle}>
			<div style={sectionDivStyle}>
				<p style={sectionTitleStyle}>
					Total
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Total:</span>
					${buildField(total,setTotal)}
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Subtotal:</span>
					${buildField(subtotal,setSubtotal)}
				</p>
				<p style={sectionInstructions}>
					Only enter one of these values.
				</p>
			</div>
			
			<div style={sectionDivStyle}>
				<p style={sectionTitleStyle}>
					Tax
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Tax:</span>
					${buildField(tax,setTax)}
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Tax Rate:</span>
					{buildField(taxRate,setTaxRate)}%
				</p>
				<p style={sectionInstructions}>
					Only enter one of these values.
				</p>
			</div>
			
			<div style={sectionDivStyle}>
				<p style={sectionTitleStyle}>
					Extra
				</p>
				
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Extra:</span>
					${buildField(extraPrinciple,setExtraPrinciple)}
				</p>
				<p style={sectionInstructions}>
					Optional. Add additional to count towards tip but not tax (e.g. discounts already applied).
				</p>
				
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Discount:</span>
					${buildField(futureDiscount,setFutureDiscount)}
				</p>
				<p style={sectionInstructions}>
					Optional. A discount which is expected to be applied pre-tax.
				</p>
			</div>
			
			<TipTable
				totalIn={total}
				subtotalIn={subtotal}
				taxIn={tax}
				taxRateIn={taxRate}
				extraIn={extraPrinciple}
				futureOffIn={futureDiscount}
			/>
		</div>
	)
}




function normalizeInput ( value ) {
	return parseInt ( Math.round ( parseFloat(value) * 100 ) )
}
function round ( value , k=100 ) {
	return parseInt ( Math.round ( value * k ) / k )
}
function format ( value ) {
	//console.log ( value )
	let dollars = parseInt ( value / 100 )
	let cents = parseInt ( Math.round ( value - dollars*100 ))
	if ( cents < 10 )
		return `${dollars}.0${cents}`
	return `${dollars}.${cents}`
}


function TipTable ({ totalIn , subtotalIn , taxIn , taxRateIn , extraIn , futureOffIn }) {
	
	var total = normalizeInput ( totalIn.length ? totalIn : "0" )
	var subtotal = normalizeInput ( subtotalIn.length ? subtotalIn : "0" )
	
	var tax = normalizeInput ( taxIn.length ? taxIn : "0" )
	var taxRate = normalizeInput ( taxRateIn.length ? taxRateIn : "0" )
	
	var extra = normalizeInput ( extraIn.length ? extraIn : "0" )
	var futureOff = normalizeInput ( futureOffIn.length ? futureOffIn : "0" )
	
	if (!( (total||subtotal) && (tax||taxRate) )) {
		return null
	}
	
	
	
	
	if ( total && tax )
	{
		subtotal = total - tax
		taxRate = round ( tax / subtotal * 10000 , 10000 )
		//console.log ( `${tax} / ${subtotal} = ${taxRate} for ${total}` )
	}
	else if ( total && taxRate )
	{
		subtotal = round ( total / ( 1 + taxRate ) )
		tax = total - subtotal
	}
	else if ( subtotal && tax )
	{
		total = subtotal + tax
		taxRate = round ( tax / subtotal * 10000 , 10000 )
	}
	else if ( subtotal && taxRate )
	{
		total = round ( subtotal * ( 1 + taxRate ) )
		tax = total - subtotal
	}
	
	
	if ( futureOff ) {
		subtotal -= futureOff
		extra += futureOff
		tax = round ( taxRate * subtotal / 10000 )
		total = subtotal + tax
	}
	
	
	var totalPrinciple = subtotal + extra
	
	
	let bigTotalStart = round ( Math.ceil((total + 1)/100) * 100 )
	
	let maxTip = round ( totalPrinciple * 0.5 )
	let bigTotalStop = bigTotalStart + maxTip
	
	var values = []
	function maybeAdd ( value ) {
		if ( value > bigTotalStart && value < bigTotalStop )
			values.push ( value )
	}
	maybeAdd ( 31416 )
	maybeAdd ( 3142 )
	maybeAdd ( 314 )
	maybeAdd ( 27183 )
	maybeAdd ( 2718 )
	maybeAdd ( 272 )
	maybeAdd ( 16180 )
	maybeAdd ( 1618 )
	maybeAdd ( 162 )
	maybeAdd ( 12345 )
	maybeAdd ( 1234 )
	maybeAdd ( 123 )
	
	for ( let bigTotal=bigTotalStart ; bigTotal<=bigTotalStop ; bigTotal+=100 )
		values.push ( bigTotal )
	values.sort()
	let rows = values.map ( bigTotal => (
		<TipRow subtotal={subtotal} extra={extra} tax={tax} bigTotal={bigTotal} key={`${bigTotal}`}/>
	))
	
	return (
		<div>
			<div style={sectionDivStyle}>
				<p style={sectionTitleStyle}>
					Inputs
				</p>
				
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Total:</span>
					${format(total)}
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Subtotal:</span>
					${format(subtotal)}
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Tip Basis:</span>
					${format(totalPrinciple)}
				</p>
				
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Tax:</span>
					${format(tax)}
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Tax Rate:</span>
					{format(taxRate)}%
				</p>
			</div>
			<div style={sectionDivStyle}>
				<p style={sectionTitleStyle}>
					Tip Search
				</p>
				
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Start:</span>
					${format(bigTotalStart)}
				</p>
				<p style={fieldPStyle}>
					<span style={fieldLabelStyle}>Max Tip:</span>
					${format(maxTip)}
				</p>
				
				{rows}
			</div>
		</div>
	)
}


function TipRow ({ subtotal , extra , tax , bigTotal }) {
	let basis = subtotal + extra
	let total = subtotal + tax
	
	let tip = bigTotal - total
	let tipRate = round ( tip / basis * 10000 , 10000 )
	
	let pStyle = fieldPStyle
	let tipStyle = {
		color: "red" ,
	}
	let tipRateStyle = {
		color: "magenta" ,
	}
	let otherNumberStyle = {
		color: "blue" ,
	}
	
	let littleLabelStyle = {
		fontSize: "80%" ,
		color: "grey" ,
	}
	
	let formattedExtra = extra ? (
		<span>
			&nbsp;
			+
			&nbsp;
			<span style={littleLabelStyle}>extra</span>
			<span style={otherNumberStyle}>${format(extra)}</span>
		</span>
	) : null
	
	return (
		<p style={pStyle}>
			<span style={tipRateStyle}>{format(tipRate)}%</span>
			
			:&nbsp;
			
			<span style={littleLabelStyle}>total</span>
			<span style={tipStyle}>${format(bigTotal)}</span>
			
			&nbsp;=&nbsp;
			
			<span style={littleLabelStyle}>sub</span>
			<span style={otherNumberStyle}>${format(subtotal)}</span>
			{formattedExtra}
			
			&nbsp;+&nbsp;
			
			<span style={littleLabelStyle}>tip</span>
			<span style={tipStyle}>${format(tip)}</span>
			
			&nbsp;+&nbsp;
			
			<span style={littleLabelStyle}>tax</span>
			<span style={otherNumberStyle}>${format(tax)}</span>
			
		</p>
	)
}

